import { CUSTOM_CHART_LABEL_MAX_WIDTH } from '../../../components/Widgets/CustomChartLabel';
import type { ArcAngles } from './PieSlice.utils';

const TAG_LABEL_HEIGHT = 20;
const TAG_LABEL_OFFSET = 8;
const TAG_LABEL_SHOW_THRESHOLD = 0.8;
export const TAG_LABEL_INITIAL_WIDTH = CUSTOM_CHART_LABEL_MAX_WIDTH;

const computeShouldShowTagLabel = (labelWidth: number, angleSpan: number, labelRadius: number) => {
  const chordLength = 2 * labelRadius * Math.sin(angleSpan / 2);
  return labelWidth * TAG_LABEL_SHOW_THRESHOLD <= chordLength;
};

export const computeTagLabelPosition = (
  angles: ArcAngles,
  labelRadius: number,
  visibilityWidth: number,
  positionWidth: number,
  selected: boolean,
  isHover: boolean
) => {
  const midAngle = (angles.startAngle + angles.endAngle) / 2;
  const angleSpan = angles.endAngle - angles.startAngle;
  const labelX = Math.cos(midAngle - Math.PI / 2) * labelRadius;
  const labelY = Math.sin(midAngle - Math.PI / 2) * labelRadius;
  const angle = Math.atan2(labelY, labelX);
  const offsetX = Math.cos(angle) * (positionWidth / 2 + TAG_LABEL_OFFSET);
  const offsetY = Math.sin(angle) * (TAG_LABEL_HEIGHT / 2 + TAG_LABEL_OFFSET);
  const showLabel = computeShouldShowTagLabel(visibilityWidth, angleSpan, labelRadius) || selected || isHover;
  return { labelX, labelY, offsetX, offsetY, showLabel, labelRadius };
};

export const createLabelRefHandler = (setWidth: (w: number) => void) => (node: HTMLElement) => {
  const observer = new ResizeObserver(([entry]) => setWidth(entry.contentRect.width));
  if (node) observer.observe(node);
  return () => {
    observer.disconnect();
  };
};
